import classNames from 'classnames';
import Image from 'next/image';
import { useDispatch } from 'react-redux';

import { Currency } from '@/icons/index';
import { actions as cabinetActions } from '@/domains/cabinet';

import Button from '../Button/Button';
import LinkNumbers, { bgVariants } from '../LinkNumbers/LinkNumbers';

import styles from './ActivateBlock.module.scss';

const ActivateBlock = ({ data, tariff, isSubscrable }) => {
  const dispatch = useDispatch();
  const tariffHandler = () => {
    dispatch(cabinetActions.setTariffModal(true));
    dispatch(cabinetActions.setIsPackageOrTariff(tariff?.type === 'tariff'));
    dispatch(cabinetActions.setSelectedTariff(tariff));
  };
  return (
    <div
      className={styles.container}
      itemScope
      itemType='http://schema.org/Product'
    >
      <div className={styles.containerTitle}>{data?.title}</div>

      <div className={`${styles.block} ${styles.payment}`}>
        <div className={styles.price}>
          {data?.price}
          <span className='currency'>
            <Currency />
          </span>
        </div>
        <div className={styles.title}>{data?.description}</div>
        <div className={styles.codeBlock}>
          <span className={styles.note}>
            {`${data?.text_before_ussd} ${data?.text_after_ussd}`}
          </span>
          <span className={styles['note-inline']}>
            {data?.text_before_ussd}
          </span>

          {data?.ussd?.length > 0 && (
            <LinkNumbers
              numbers={data?.ussd}
              isTel
              isLight
              bgVariant={bgVariants.bgWhite}
            />
          )}
          <span className={styles['note-inline']}>{data?.text_after_ussd}</span>
        </div>
        {isSubscrable && (
          <div className={styles.action}>
            <Button className={styles.button} onClick={tariffHandler}>
              {data?.button_text}
            </Button>
          </div>
        )}
      </div>
      <div className={classNames([styles.block, styles.qrCodeBlock])}>
        <div className={styles.qrTextContainer}>
          {data?.qr_title && (
            <div className={styles.title}>{data?.qr_title}</div>
          )}
          {data?.qr_description && (
            <div className={styles.qrTooltip}>
              <span
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: data?.qr_description }}
              ></span>
            </div>
          )}
        </div>

        <div className={styles.qrCode}>
          <div className={styles.image}>
            <Image
              src={data?.qr_image}
              alt={data?.qr_title}
              title={data?.qr_title}
              loading='lazy'
              layout='fill'
            />
          </div>
        </div>
        <div className={styles.mobileLinks}>
          <a
            title={data?.title}
            aria-label={data?.title}
            href='https://onelink.to/3shfk7'
            target='_blank'
            rel='noreferrer'
          >
            <div className={styles.logo}>
              <Image
                src='/assets/play-store.svg'
                alt='play-store'
                title='Play-Store'
                width={120}
                height={40}
              />
            </div>
            <div className={styles.logo}>
              <Image
                src='/assets/app-store.svg'
                alt='app-store'
                title='App-Store'
                width={120}
                height={40}
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ActivateBlock;
